import styled from 'styled-components'

import { Image } from '@application/Interfaces/Atoms/Image'
import { Button as ButtonBase } from '@application/Interfaces/Molecules/Button'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    background: ${(props) => props.theme.color[props.mode === 'Light' ? 'g200' : 'p600']};
`

export const Button = styled(ButtonBase)`
    width: 100%;

    button {
        width: 100%;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        width: auto;
    }
`

export const Cover = styled(Image)`
    max-height: 400px;
    min-height: 200px;
    width: 100%;
    max-width: 970px;
    margin: 0 auto;
    border-radius: 20px;
    overflow: hidden;

    @media ${(props) => props.theme.query.min.tablet} {
        max-width: 100%;
        object-fit: cover;
    }
`

export const ImageWrapper = styled.a`
    display: flex;
    cursor: pointer;
    position: relative;
    margin: 100px auto 0px;
`

export const VideoIframe = styled.iframe`
    height: 100%;
    width: 100%;
    background-position: center;
`

export const VideoWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
`
